import { render } from "./CFAHeader.vue?vue&type=template&id=5fbd8338&scoped=true"
import script from "./CFAHeader.vue?vue&type=script&lang=js"
export * from "./CFAHeader.vue?vue&type=script&lang=js"

import "./CFAHeader.vue?vue&type=style&index=0&id=5fbd8338&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbd8338"]])

export default __exports__